export enum PAGE_NO {
    ORDER = '51d1ebb719',
    BP = 'cea858702d',
    COMPLETE_ORDER = 'c5cbf4e716',
    DELIVERY_DOC = ''
}